import { array, object, string } from "yup";
import { useForm, useFormState } from "react-hook-form";

import Validations from "@helpers/validations";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useParams } from "react-router-dom";

const defaultValues = {
    name       : "",
    description: "",
    operator   : "",
    conditions : [
        {
            attribute         : "",
            attributeCondition: "",
            attributeValue    : 0
        }
    ]
};

const useUpsert = (props) => {
    const { platformId } = useParams();
    const { modalConfig:{ row }, handleModal, getSegments } = props;
    const { loading, axiosInstance } = useAxios({ base: "panel" });

    const { requiredValidation, numberValidation } = Validations();
    const methods = useForm({
        defaultValues,
        resolver: yupResolver(object().shape({
            name       : requiredValidation({ name: "Name" }),
            description: string(),
            operator   : requiredValidation({ name: "Operator" }),
            conditions : array().of(
                object().shape({
                    attribute         : requiredValidation({ name: "Attribute" }),
                    attributeCondition: requiredValidation({ name: "Condition" }),
                    attributeValue    : numberValidation({ name: "Value", min: 0 })
                })
            )
        }))
    });

    const { control, handleSubmit, reset } = methods;

    const { isDirty } = useFormState({ control });

    useEffect(() => {
        if (size(row)) {
            reset({
                name       : row.name,
                description: row.description,
                operator   : row.event_logic.operator,
                conditions : row.event_logic.conditions
            });
        } else {
            reset(defaultValues);
        }
    }, [row]);

    const onSubmit = () => {
        handleSubmit(async (data) => {
            const payload = {
                name       : data.name,
                description: data.description,
                event_logic: {
                    operator  : data.operator,
                    conditions: data.conditions.map((item) => ({
                        ...item,
                        type: "number"
                    }))
                }
            };
            if (row._id) {
                await axiosInstance.patch(`/segments/${platformId}/${row._id}`, payload);
            } else {
                await axiosInstance.post(`/segments/${platformId}`, payload);
            }
            handleModal();
            getSegments();
        })();
    };

    return {
        onSubmit, methods, updateLoading: loading, isDirty 
    };
};
export default useUpsert;